import React from "react";

export const Contact = (props) => {
	return (
		<div>
			<div id="contact" style={{"background": "#214150"}}>
				<div className="container">
					<div className="row">
						<div className="col-md-8 col-md-offset-2 text-center">
							<div className="section-title">
								<h2 style={{"color": "#FFFFFF"}}>Book jeres arrangement</h2>
								<p style={{"color": "#CCDDDD", "fontSize": "18px"}}>
									Send os en e-mail, og vi vender tilbage hurtigst muligt med et tilbud.
								</p>
							</div>

							<div style={{
								"background": "rgba(255,255,255,0.08)",
								"borderRadius": "12px",
								"padding": "40px",
								"marginBottom": "40px"
							}}>
								<div style={{"fontSize": "4em", "marginBottom": "16px"}}>✉️</div>
								<p style={{"color": "#CCDDDD", "fontSize": "16px", "marginBottom": "24px"}}>
									Skriv til os med antal personer, ønsket dato og hvilken type arrangement I ønsker – så sender vi jer et tilbud.
								</p>
								<a
									href="mailto:haven@frederiksbergevents.dk?subject=Booking%20foresp%C3%B8rgsel"
									className="btn btn-lg"
									style={{
										"background": "#F5C518",
										"color": "#214150",
										"fontWeight": "bold",
										"border": "none",
										"padding": "16px 48px",
										"fontSize": "20px",
										"borderRadius": "4px",
										"textDecoration": "none"
									}}
								>
									haven@frederiksbergevents.dk
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div id="footer">
				<div className="container text-center">
					<p>
						&copy; {new Date().getFullYear()} Haven – Frederiksberg Events &nbsp;|&nbsp;
						Allégade 11, 2000 Frederiksberg &nbsp;|&nbsp;
						<a href="mailto:haven@frederiksbergevents.dk" style={{"color": "#888"}}>
							haven@frederiksbergevents.dk
						</a>
					</p>
					<p>
						{props.data && props.data.facebook && (
							<a href={props.data.facebook} target="_blank" rel="noopener noreferrer" style={{"marginRight": "12px"}}>
								<i className="fa fa-facebook"></i>
							</a>
						)}
						{props.data && props.data.instagram && (
							<a href={props.data.instagram} target="_blank" rel="noopener noreferrer">
								<i className="fa fa-instagram"></i>
							</a>
						)}
					</p>
				</div>
			</div>
		</div>
	);
};
